import React, { useEffect, useState } from "react";

import Board from "./Board";

import { Get } from "../../../../utils/request";
import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { Show } from "../../../../actions/SnackbarActions";
import { Pagination } from "@mui/material";

const Table = props => {

    const {
        search = ""
    } = props;

    const [categories, SetCategories] = useState([]);
    const [loading, SetLoading] = useState(false);

    const [page, SetPage] = useState(1);
    const [maxPage, SetMaxPage] = useState(1);

    const dispatch = useDispatch();

    const GetData = async () => {
        SetLoading(true);
        let response = await Get(`pre-register?search=${search}&page=${page}`);
        SetLoading(false);

        if (response?.status === true) {
            SetCategories(response?.preRegisters);
            SetMaxPage(response?.pagination?.last_page);
        } else if (!response) dispatch(Show({
            show: true,
            message: "Falha ao carregar categorias",
            severity: "warning"
        }));
    }

    useEffect(() => {
        GetData();
    }, [search, page]);

    return (
        <div>
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>E-mail</th>
                            <th>Whatsapp</th>
                            <th>Curso</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!loading && categories?.map((value, index) => (
                            <Board
                                key={index}
                                id={value["id"]}
                                name={value["name"]}
                                email={value?.email}
                                phone={value?.phone}
                                course={value?.course.nome}
                                OnDelete={GetData}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="w100 flex jcc">
                <CircularProgress hidden={!loading}/>
            </div>
            <Pagination
                className={(maxPage == 1 ? "hide" : "")}
                style={{display: "flex", justifyContent: "flex-end"}} 
                count={maxPage} 
                value={page}
                onChange={(_, value) => SetPage(value)}
            />
        </div>
    );
}

export default Table;